import { Injectable } from '@angular/core';
import { AuthTokenResponse } from '../interfaces/Responses/AuthTokenResponse';
import { AssetInfo } from '../interfaces/AssetInfo';


@Injectable({
  providedIn: 'root'
})

export class ConfigService {

  token: string | null = null;
  tokenType: string | null = null;
  assetInfo: AssetInfo | null = null;
  language!: string;


  constructor() {
    this.setBrowserLanguageAsCurrent();
  }

  public addSecurityToken(authTokenResponse: AuthTokenResponse) {
    this.token = authTokenResponse.token;
    this.tokenType = authTokenResponse.authType;
  }

  setBrowserLanguageAsCurrent() {
    this.language = window.navigator.language.substring(0, 2);
    console.log(`Browser language detected: ${this.language}`);
  }

  changeLanguage(newLanguage: string) {
    this.language = newLanguage;
  }
}
